import { gql } from '@apollo/client'
import { useLazyQuery } from '@apollo/client'

export const GET_ADVANCED_SEARCH_RESULTS = gql`
  query AdvancedSearch(
    $query: String,
    $entity: [String],
    $page: Int,
    $limit: Int
    $isInstitutionSearch: Boolean!
    $isContactSearch: Boolean!
    $isFundSearch: Boolean!
    $tickerId: [String],
    $securityId: [String],
    $filter: SearchFilter,
    $useElasticSearch: Boolean
  ) {
    advancedSearch(
      query: $query,
      entity: $entity,
      filter: $filter,
      page: $page,
      limit: $limit,
      useElasticSearch: $useElasticSearch
    ) {
      items {
        id
        score
        entityConnection(securityId: $securityId, tickerId: $tickerId) {
          ... on InstitutionSearchDTO @include(if: $isInstitutionSearch) {
            country
            entityId
            institutionName
            type
            entity {
              id
              institutionType
              addressConnection {
                items {
                  addressLine1
                  city
                  countryCode
                  countryName
                  hq
                  postalCode
                  stateProvinceCode
                  stateProvinceName
                }
              }
            }
          }
          ... on ContactSearchDTO @include(if: $isContactSearch) {
            fullName
            type
            entity {
              id
              q4EntityId
              fullName
              firstName
              lastName
              source
              favoriteConnection {
                items {
                  id
                  lists
                }
              }
              jobs {
                id
                active
                address1
                city
                cityStateZip
                country
                countryName
                directPhone
                email
                entityId
                fax
                functions
                institutionName
                institutionType
                metro
                phone
                postalCode
                region
                stateProvince
                title
              }
            }
          }
          ... on FundSearchDTO @include(if: $isFundSearch) {
            entityId
            fundName
            institutionId
            type
            entity {
              id
              institutionConnection {
                items {
                  id
                  addressConnection {
                    items {
                      addressLine1
                      city
                      countryCode
                      countryName
                      hq
                      postalCode
                      stateProvinceCode
                      stateProvinceName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export function useAdvancedSearchQuery () {
  return useLazyQuery(GET_ADVANCED_SEARCH_RESULTS, {
    fetchPolicy: 'no-cache'
  })
}
